// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorValidate_wrapper__8Olpi","error":"ErrorValidate_error__lwdHF"};